import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Área de Formação',
  path: '/pessoal/pesareaformacao',
  name: 'pesareaformacao',
  component: () => import('@/views/pessoal/pesareaformacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.AREADEFORMACAONOVO_MENU_1400800199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Área de Formação',
  path: '/pessoal/pesareaformacao/cadastro/:id?',
  parent: 'pesareaformacao',
  name: 'pesareaformacao_create',
  component: () => import('@/views/pessoal/pesareaformacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.AREADEFORMACAONOVO_MENU_1400800199],
  },
  goesToMenu: true,
 },
]
